import {
  IFormattedMadlibOptions,
  INetworkMidLevelMadlibModel,
  INetworkMidLevelFilterOption,
  ISuperFilterState,
} from './../network-mid-level.models';
import { switchMap, startWith } from 'rxjs/operators';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'network-dashboard-mad-lib',
  template: require('./network-dashboard-mad-lib.component.html'),
  styles: [require('./network-dashboard-mad-lib.scss')],
})
export class NetworkDashboardMadLibComponent {
  @Input() madlibOptions;
  @Input() madlibModel;
  @Output() madlibChangeEmitter = new EventEmitter();
  @Output() superFilterConfirmationEmitter = new EventEmitter();
  @Output() superFilterCancelationEmitter = new EventEmitter();

  public superFilterState$: Observable<{ schoolState: ISuperFilterState; studentState: ISuperFilterState }>;

  ngOnInit(): void {
    this.superFilterState$ = this.madlibModel.filters.valueChanges.pipe(
      startWith(this.madlibModel.filters.value),
      switchMap(this.getSuperFilterState$.bind(this, this.madlibOptions)),
    );
  }

  public emitMadlibChange({ key, value, human }, dimension: 'FOCUS' | 'FILTER' | 'GROUP') {
    this.madlibChangeEmitter.emit({ key, value, human, dimension });
  }

  public emitSuperFilterCancelation() {
    this.superFilterCancelationEmitter.emit();
  }

  public emitSuperFilterConfirmation() {
    this.superFilterConfirmationEmitter.emit();
  }

  private getSuperFilterState$(madlibOptions: IFormattedMadlibOptions, madlibModel: INetworkMidLevelMadlibModel) {
    return Observable.create(observer => {
      const schoolState = this.getSchoolSuperFilterState(madlibModel, madlibOptions.filterDropdownOptions.schoolFilter);
      const studentState = this.getStudentSuperFilterState(
        madlibModel,
        madlibOptions.filterDropdownOptions.studentFilter,
      );
      observer.next({ schoolState, studentState }), observer.complete();
    });
  }

  private getSchoolSuperFilterState(
    madlibModel: INetworkMidLevelMadlibModel,
    filterOptions: Array<INetworkMidLevelFilterOption>,
  ) {
    const filterLabel = 'School';
    const isModified = this.isFilterModified(madlibModel, filterOptions);
    const pillLabel = isModified ? 'Some Schools' : 'All Schools';
    return { filterLabel, pillLabel, isModified };
  }

  private getStudentSuperFilterState(
    madlibModel: INetworkMidLevelMadlibModel,
    filterOptions: Array<INetworkMidLevelFilterOption>,
  ) {
    const filterLabel = 'Student';
    const isModified = this.isFilterModified(madlibModel, filterOptions);
    const pillLabel = isModified ? 'Some Students' : 'All Students';
    return { filterLabel, pillLabel, isModified };
  }

  private isFilterModified(
    madlibModel: INetworkMidLevelMadlibModel,
    filterOptions: Array<INetworkMidLevelFilterOption>,
  ) {
    return filterOptions.some(({ key, filter_type, filter_values }) => {
      if (filter_type === 'dropdown') return madlibModel[key];
      if (filter_type === 'multiselect') return madlibModel[key].length !== filter_values.length;
      else return false;
    });
  }
}
